import React from 'react';
const OfferSeekTypePanel = ({ offerSeekType }) => offerSeekType === 'service' ? <p>Service</p> : <p>Good(s)</p>;
export default OfferSeekTypePanel;
